import { render, staticRenderFns } from "./commentIndex.vue?vue&type=template&id=fc32add4&scoped=true"
import script from "./commentIndex.vue?vue&type=script&lang=js"
export * from "./commentIndex.vue?vue&type=script&lang=js"
import style0 from "./commentIndex.vue?vue&type=style&index=0&id=fc32add4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc32add4",
  null
  
)

export default component.exports